<header class="page_header">
    <div class="header-section">
      <div class="left">
        <div class="title">Receipts</div>
      </div>
      <div class="right">
        <button class="btn tertiary_button adv-payment-btn" (click)="recordPayment(true)">
          <app-svg-icon [path]="'assets/icons/plus_icon.svg'"></app-svg-icon>Advance Payment
        </button>
        <button class="btn primary_button record-payment-btn" (click)="recordPayment(false)">
            <app-svg-icon [path]="'assets/icons/plus_icon.svg'"></app-svg-icon>Record Payment
        </button>
      </div>
    </div>
  </header>

  <app-tos-table
          [showTableStats]="false"
          [searchBarConfig]="PaymentConfig.searchBarConfig"
          [filterConfig]="PaymentConfig.filterConfig"
          [tableMeta]="tableMeta"
          [tableMenuOptions]="menuOptions"
          [(dataListRequest)]="tableListRequest"
          [dataListResponse]="tableListData"
          [(allTableRecordsSelected)]="allTableRecordsSelected"
          [(selectedItems)]="selectedItems"
          (tosTableAction)="getTableList()"
          (tableMenuOptionSelected)="handleMenuOptionSelection($event)"
  ></app-tos-table>
